<template>
  <div class="fade-in interview">
    <div class="columns">
      <div class="column is-full">
        <h1 class="title">Interviews</h1>
      </div>
      <div class="is-clearfix"></div>
    </div>

    <table class="table is-striped">
      <thead>
        <tr>
          <th style="width:200px;">Keyword</th>
          <th style="width:400px;">Link</th>
          <th style="width:150px;">Interview Type</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="interview in interviews">
          <td>
            <a :title="interview.attributes.scheduleMessage">{{
              interview.attributes.keyword
            }}</a>
          </td>
          <td>
            <a
              v-if="!interview.attributes.kind.startsWith('Referral_')"
              :href="scheduleUrl(interview.attributes.keyword)"
              target="_blank"
              >{{ scheduleUrl(interview.attributes.keyword) }}</a
            >
            <router-link
              v-if="interview.attributes.kind === 'Referral_Provider'"
              :to="{
                name: 'interview-providers',
                params: { id: interview.id }
              }"
              >View provider links</router-link
            >
            <span v-if="interview.attributes.kind === 'Referral_Patient'"
              >Patient will receive personalized link from provider
              referral</span
            >
          </td>
          <td>{{ interview.attributes.kind }}</td>
          <td class="has-text-centered">
            <i
              v-if="!interview.attributes.kind.startsWith('Referral_')"
              class="fa fa-mobile-phone pointer mr1"
              @click="togglePusher(interview.id)"
            ></i>

            <router-link
              v-if="
                !interview.attributes.kind.startsWith('Referral_') &&
                  $can('interview:create|interview:manage')
              "
              :to="{ name: 'interview-log', params: { id: interview.id } }"
              class="has-text-black"
            >
              <i class="fa fa-file-text-o fa-small pointer mr1"></i>
            </router-link>

            <router-link
              v-if="$can('interview:create|interview:manage')"
              :to="{ name: 'interview-edit', params: { id: interview.id } }"
              class="has-text-black"
            >
              <i class="fa fa-pencil fa-small mr1"></i>
            </router-link>

            <i
              v-if="!deleteLoading && $can('interview:create|interview:manage')"
              class="fa fa-times fa-small pointer"
              @click="interviewDelete(interview.id)"
            ></i>
            <i
              v-if="deleteLoading === interview.id"
              class="fa fa-refresh fa-spin"
            ></i>
          </td>
        </tr>
      </tbody>
    </table>

    <div :class="['modal', { 'is-active': showPusher }]">
      <div class="modal-background"></div>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">Send interview to:</p>
          <button class="delete" @click="togglePusher"></button>
        </header>
        <section class="modal-card-body">
          <form @submit.prevent="sendText">
            <div class="field">
              <label class="label">Name</label>
              <div class="control mt-2">
                <input
                  type="text"
                  class="input"
                  v-model="text.name"
                  name="name"
                />
              </div>
            </div>

            <div class="field">
              <label class="label">Phone Number</label>
              <div class="control has-icons-right mt-2">
                <masked-input
                  :class="['input', { 'is-danger': sendError }]"
                  type="tel"
                  name="phone"
                  placeholderChar="_"
                  :mask="[
                    /[1-9]/,
                    /\d/,
                    /\d/,
                    '-',
                    /\d/,
                    /\d/,
                    /\d/,
                    '-',
                    /\d/,
                    /\d/,
                    /\d/,
                    /\d/
                  ]"
                  v-model="text.phone"
                ></masked-input>
                <span class="icon is-small is-right" v-if="sendError">
                  <i class="fa fa-warning"></i>
                </span>
              </div>
              <p v-if="sendError" class="help is-danger">{{ sendError }}</p>
            </div>

            <div class="field is-grouped">
              <div class="control">
                <button type="button" class="button mr1" @click="togglePusher">
                  Cancel
                </button>
                <button
                  :class="['button', 'is-primary', { 'is-loading': sending }]"
                >
                  Send
                </button>
              </div>
            </div>
          </form>
        </section>
      </div>
    </div>

    <vue-toastr ref="toastr"></vue-toastr>
    <alert ref="alert" title="Confirm Delete" :onConfirm="onDelete"
      >Are you sure you want to delete this interview?</alert
    >
  </div>
</template>

<script>
import _ from "lodash";
import maskedInput from "vue-text-mask";
import InterviewsService from "@/services/InterviewsService";
import alert from "@/components/alert";

export default {
  name: "interview-index",

  components: {
    maskedInput,
    alert
  },

  data() {
    return {
      showPusher: false,
      interviewId: null,
      sending: false,
      sendError: "",
      text: {
        name: "",
        phone: ""
      },
      deleteLoading: null
    };
  },

  computed: {
    interviews() {
      let interviews = this.$store.getters["interview/list"];
      interviews = _.filter(interviews, function(i) {
        return i.attributes.keyword != null;
      });
      return interviews;
    },
    practice() {
      return this.$store.getters["practice/current"];
    }
  },

  methods: {
    scheduleUrl(keyword) {
      return InterviewsService.url(this.practice.subdomain, keyword);
    },
    load() {
      InterviewsService.list();
    },
    togglePusher(interviewId) {
      this.showPusher = !this.showPusher;
      this.interviewId = interviewId;
    },
    sendText() {
      this.sending = true;
      InterviewsService.sendText(this.interviewId, this.text)
        .then(data => {
          this.sending = false;
          if (data.sent) {
            this.showPusher = false;
            this.text = { name: "", phone: "" };
            this.$refs.toastr.s("The message has been sent.");
          } else {
            this.$refs.toastr.e("There was a problem sending the message.");
          }
        })
        .catch(error => {
          this.sending = false;
          this.sendError = error.response.data.message;
          this.$refs.toastr.e("There was a problem sending the message.");
        });
    },
    interviewDelete(id) {
      this.$refs.alert.open();
      this.interviewId = id;
    },
    onDelete() {
      this.deleteLoading = this.interviewId;
      InterviewsService.delete(this.interviewId).then(() => {
        this.deleteLoading = null;
        this.$refs.toastr.s("The interview has been deleted.");
      });
    }
  },

  mounted() {
    this.load();
  }
};
</script>

<style lang="scss" scoped>
.fa-small {
  font-size: 99%;
  margin-top: 3px;
}
</style>
